const initialState = {
  ieltsExams: [],
  currentExam: null,
  ieltsParts: [],
  questions: [],
  currentAttempt: null,
  isLoadingIELTS: false,
  isLoadingParts: false,
  isLoadingQuestions: false,
  ieltsBandCriterias: [],
  currentBandCriteria: null,
  ieltsBandFeedback: [],
  currentBandFeedback: null,
};

const ieltsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_IELTS_EXAMS":
      return {
        ...state,
        ieltsExams: action.payload,
      };
    case "SET_LOADING_IELTS":
      return {
        ...state,
        isLoadingIELTS: action.payload,
      };
    case "FETCH_IELTS_QUESTIONS":
      return {
        ...state,
        questions: action.payload,
      };
    case "SET_LOADING_IELTS_QUESTIONS":
      return {
        ...state,
        isLoadingQuestions: action.payload,
      };
    case "FETCH_IELTS_PARTS":
      return {
        ...state,
        ieltsParts: action.payload,
      };
    case "SET_LOADING_IELTS_PARTS":
      return {
        ...state,
        isLoadingParts: action.payload,
      };
    case "FETCH_IELTS_EXAM":
      return {
        ...state,
        currentExam: action.payload,
      };
    case "CREATE_IELTS_ATTEMPT":
      return {
        ...state,
        currentAttempt: action.payload,
      };
    case "UPDATE_IELTS_ATTEMPT":
      return {
        ...state,
        currentAttempt: {
          ...state.currentAttempt,
          ...action.payload,
        },
      };
    case "SUBMIT_IELTS_ATTEMPT":
      return {
        ...state,
        currentAttempt: action.payload,
      };
    case "FETCH_IELTS_CRITERIAS":
      return {
        ...state,
        ieltsBandCriterias: action.payload,
      };
    case "FETCH_IELTS_BAND_FEEDBACK":
      return {
        ...state,
        ieltsBandFeedback: action.payload,
      };
    default:
      return state;
  }
};

export default ieltsReducer;
